import abTests from '@/js/common/Domain/Service/abTests';
import template from './noReview.html';

export default class TopHotelsReviews extends Backbone.Epoxy.View {
    initialize() {
    }

    load() {
        let query = abTests.hasTest('IN-4752') ? '&version=1' : '';
        return new Promise((resolve, reject) => {
            jQuery.ajax({
                url: `/hotel/hotel-top-totels-reviews?id=${window.appConfig.hotelInfo.id}${query}`,
                type: 'POST',
            }).done((response) => {
                const { result } = response;
                if (response.success === true && result) {
                    try {
                        this.$el.html(result);
                        resolve();
                    } catch {
                        this.$el.html(template);
                        reject();
                    }
                } else {
                    this.$el.html(template);
                    reject();
                }
            }).fail(() => {
                this.$el.html(template);
                reject();
            });
        });
    }
}